export default function getItemFromId(id, inputArr) {
  if (!inputArr || !id) return null;
  var index = inputArr.findIndex(function (item) {
    return (item === null || item === void 0 ? void 0 : item.id) === id;
  });

  if (index > -1) {
    return inputArr[index];
  } else {
    return null;
  }
}